import { searchVehicles, getFormItems as getMotorFormItems, uploadAnnotationToS3, submitInspection as motorSubmitInspection, getPdfFromS3, getInspectionDetailsFromMM, updateInspectionInMM, removeInspectionDetailsInMM, createInspectionDetailsInMM, getAnnotationImageFromS3, uploadPdfToS3, generatePdfFilename, generateAnnotationFilename } from './motorApiService';

export const apiService = {
  searchVehicle: (searchInput) => searchVehicles(searchInput),

  getFormItemsAndCategories: () => getMotorFormItems(),

  getFormItems: async () => {
    const result = await getMotorFormItems();
    return { formItems: result.formItems };
  },

  getCategories: async () => {
    const result = await getMotorFormItems();
    return { categories: result.categories };
  },

  createInspection: (inspectionData, user) => motorSubmitInspection(inspectionData, user),

  downloadPDF: (contractNo) => getPdfFromS3(contractNo),

  uploadAnnotation: (vehicleId, imageFile) => uploadAnnotationToS3(vehicleId, imageFile),

  getSubmittedInspectionDetails: (contractNo) => getInspectionDetailsFromMM(contractNo),

  updateInspectionRecord: (data) => updateInspectionInMM(data),

  removeInspectionDetails: (contractNo) => removeInspectionDetailsInMM(contractNo),

  createInspectionDetails: (data) => createInspectionDetailsInMM(data),

  getAnnotationImage: (vehicleId) => getAnnotationImageFromS3(vehicleId),

  uploadPdf: (contractNo, pdfBlob) => uploadPdfToS3(contractNo, pdfBlob),

  getPdfFilename: (contractNo) => generatePdfFilename(contractNo),

  getAnnotationFilename: (vehicleId) => generateAnnotationFilename(vehicleId),
};
